export const DEVICE_ID = (typeof window !== "undefined" && window.matrixPOS?.deviceId) || "web-register";

// Public https address of the hosted web app (phones can open it). Inside the Electron shell the
// page origin is app://pos, which is not reachable from other devices, so fall back to the cloud URL.
export function publicWebOrigin() {
  const origin = window.location.origin;
  if (/^https?:/.test(origin)) return origin;
  return process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "");
}

// Prints the element with id="receipt". Desktop app prints silently to the configured receipt printer.
export async function printReceipt() {
  if (window.matrixPOS?.print) {
    try { await window.matrixPOS.print(); return; } catch (e) { /* fall through to dialog */ }
  }
  window.print();
}
